import { useQuery } from "@tanstack/react-query";
import { getJobsV2 } from "@/app/_firebase/jobs";
import { useUserContext } from "./useUserContext";

const useGetJobsWithCacheV2 = (enabled: boolean = true) => {
  const user = useUserContext();

  return useQuery({
    // "jobs" must lead the key so the existing invalidateQueries({ queryKey:
    // ["jobs"] }) calls and the dashboard's cached-jobs fast path can hit it.
    queryKey: ["jobs", user.uid],
    queryFn: () => getJobsV2(user.uid),
    enabled: !!user.uid && enabled,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetJobsWithCacheV2;